module.exports = __webpack_public_path__ + "img/Commercial_Record.7c605982.png";